// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { getWebstories } from "service/api";

// const WebStories2 = () => {
//     const [webStories, setWebStories] = useState([]);
//     const navigate = useNavigate();
//     const [searchQuery, setSearchQuery] = useState("");
//     const [isListening, setIsListening] = useState(false);

//     // Fetch Web Stories
//     useEffect(() => {
//         const fetchStories = async () => {
//             try {
//                 const data = await getWebstories();
//                 if (data.success && Array.isArray(data.webstories)) {
//                     setWebStories(data.webstories);
//                 }
//             } catch (error) {
//                 console.error("Error fetching web stories:", error);
//             }
//         };
//         fetchStories();
//     }, []);

//     const handleSearch = async (e) => {
//         const query = e.target.value;
//         setSearchQuery(query);

//         if (!query) {
//             fetchStories(); // If query is empty, reset to all properties
//             return;
//         }

//         try {
//             const data = await searchProperties(query);
//             console.log("Search Response:", data); // Debugging

//             // Ensure properties is always an array
//             if (data?.success && Array.isArray(data.webstories)) {
//                 setWebStories(data.webstories);
//             } else {
//                 console.error("Invalid search response format:", data);
//                 setWebStories([]);
//             }
//         } catch (error) {
//             console.error("Search API Error:", error);
//             setWebStories([]);
//         }
//     };

//     const toggleListening = () => {
//         if (!isListening) {
//             startListening();
//         } else {
//             stopListening();
//         }
//     };
//     // 🟢 Voice Search Function
//     const startListening = () => {
//         if (!("webkitSpeechRecognition" in window)) {
//             alert("Your browser does not support voice search.");
//             return;
//         }

//         const recognition = new window.webkitSpeechRecognition();
//         recognition.lang = "en-US";
//         recognition.interimResults = false;
//         recognition.maxAlternatives = 1;

//         recognition.onstart = () => setIsListening(true);
//         recognition.onend = () => setIsListening(false);

//         recognition.onresult = (event) => {
//             const spokenText = event.results[0][0].transcript;
//             setSearchQuery(spokenText);
//             handleSearch({ target: { value: spokenText } });
//         };

//         recognition.start();
//         console.log("Mic is ON");
//     };

//     const stopListening = () => {
//         setIsListening(false);
//         // Stop the speech recognition logic
//         console.log("Mic is OFF");
//     };

//     const getOrdinalSuffix = (day) => {
//         if (day > 3 && day < 21) return "th"; // Covers 4th-20th
//         const lastDigit = day % 10;
//         if (lastDigit === 1) return "st";
//         if (lastDigit === 2) return "nd";
//         if (lastDigit === 3) return "rd";
//         return "th";
//     };

//     const formatDateWithSuffix = (isoString) => {
//         const date = new Date(isoString);
//         const day = date.getDate();
//         const month = date.toLocaleDateString("en-GB", { month: "long" });
//         const year = date.getFullYear();
//         return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
//     };

//     const truncateTitle = (title, charLimit = 20) => {
//         if (title.length > charLimit) {
//             return title.slice(0, charLimit) + "..."; // Trim to 20 characters and add "..."
//         }
//         return title; // Return full title if it's within the limit
//     };



//     if (webStories.length === 0) return <p>Loading stories...</p>;

//     // Extract only first image, title, and date from each story
//     const uniqueStories = webStories
//         .map((story) => ({
//             img: story.details?.[0]?.img,
//             title: story.title,
//             date: story.date, // Assuming the API provides a 'date' field
//         }))
//         .filter((story) => story.img); // Remove undefined/null images

//     return (
//         <div style={{ display: "flex", gap: "10px", justifyContent: "center", flexWrap: "wrap" }}>
//             {uniqueStories.map((story, index) => (
//                 <div
//                     key={index}
//                     style={{
//                         position: "relative",
//                         width: "200px",
//                         height: "300px",
//                         overflow: "hidden",
//                         cursor: "pointer",
//                         backgroundColor: "#1E253A",
//                         borderRadius: "10px",
//                     }}
//                     onClick={() => navigate(`/webstories/${story.title}`)}
//                 >
//                     {/* Display image */}
//                     <img
//                         src={`https://aiinrealestate.in/api${story.img}`}
//                         alt={`Story ${index + 1}`}
//                         style={{ width: "100%", height: "100%", objectFit: "cover" }}
//                     />

//                     {/* Title on top-left */}
//                     <div
//                         style={{
//                             position: "absolute",
//                             top: "8px",
//                             left: "8px",
//                             backgroundColor: "rgba(0, 0, 0, 0.6)",
//                             color: "#fff",
//                             padding: "4px 6px",
//                             fontSize: "12px",
//                             fontWeight: "bold",
//                             borderRadius: "4px",
//                         }}
//                     >
//                         {truncateTitle(story.title)}
//                     </div>

//                     {/* Date on bottom-left */}
//                     <div
//                         style={{
//                             position: "absolute",
//                             bottom: "8px",
//                             left: "8px",
//                             backgroundColor: "rgba(0, 0, 0, 0.6)",
//                             color: "#fff",
//                             padding: "2px 6px",
//                             fontSize: "10px",
//                             borderRadius: "4px",
//                         }}
//                     >
//                         {formatDateWithSuffix(story.date)}
//                     </div>
//                 </div >
//             ))}
//         </div >
//     );
// };

// export default WebStories2;

import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getWebstories, searchwebstories } from "service/api";
import { Mic, MicOff, Search, X } from "lucide-react"; // Icon library
import { FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import Footer from "components/VerticalLayout/Footer";

const WebStories2 = () => {
    const [webStories, setWebStories] = useState([]);
    const [filteredStories, setFilteredStories] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [isListening, setIsListening] = useState(false);
    const navigate = useNavigate();
    const [visibleRows, setVisibleRows] = useState(1);
    const [loading, setLoading] = useState(true);
    const containerRef = useRef(null);
    const storiesPerRow = 10;

    // Fetch Web Stories
    useEffect(() => {
        const fetchStories = async () => {
            try {
                const data = await getWebstories();
                if (data.success && Array.isArray(data.webstories)) {
                    setWebStories(data.webstories);
                    setFilteredStories(data.webstories); // Initially show all
                }
            } catch (error) {
                console.error("Error fetching web stories:", error);
            }
        };
        fetchStories();
    }, []);



    // Search Function
    // const handleSearch = (query) => {
    //     setSearchQuery(query);
    //     if (!query) {
    //         setFilteredStories(webStories); // Reset if empty
    //         return;
    //     }
    //     const lowerCaseQuery = query.toLowerCase();
    //     const filtered = webStories.filter(story =>
    //         story.title.toLowerCase().includes(lowerCaseQuery) ||
    //         story.details.some(detail => detail.description.toLowerCase().includes(lowerCaseQuery))
    //     );
    //     setFilteredStories(filtered);
    // };
    const handleSearch = async (query) => {
        setSearchQuery(query);

        if (!query) {
            setFilteredStories(webStories); // Reset if search is empty
            return;
        }

        try {
            const response = await searchwebstories(query); // Call API to search web stories
            if (response.success) {
                setFilteredStories(response.webstories); // Update with API results
            } else {
                setFilteredStories([]); // No results found
            }
        } catch (error) {
            console.log("Error in handleSearch:", error);
            setFilteredStories([]); // Handle errors gracefully
        }
    };

    // Voice Search Function
    const startListening = () => {
        if (!("webkitSpeechRecognition" in window)) {
            alert("Your browser does not support voice search.");
            return;
        }

        const recognition = new window.webkitSpeechRecognition();
        recognition.lang = "en-US";
        recognition.interimResults = false;
        recognition.maxAlternatives = 1;

        recognition.onstart = () => setIsListening(true);
        recognition.onend = () => setIsListening(false);

        recognition.onresult = (event) => {
            const spokenText = event.results[0][0].transcript;
            setSearchQuery(spokenText);
            handleSearch(spokenText);
        };

        recognition.start();
    };

    const stopListening = () => {
        setIsListening(false);
    };

    // Reset Search
    const clearSearch = () => {
        setSearchQuery("");
        setFilteredStories(webStories);
    };

    const handleCategoryClick = (category) => {
        setSearchQuery(category);
        handleSearch(category);
    };

    const getOrdinalSuffix = (day) => {
        if (day > 3 && day < 21) return "th"; // Covers 4th-20th
        const lastDigit = day % 10;
        if (lastDigit === 1) return "st";
        if (lastDigit === 2) return "nd";
        if (lastDigit === 3) return "rd";
        return "th";
    };
    const formatDateWithSuffix = (isoString) => {
        const date = new Date(isoString);
        const day = date.getDate();
        const month = date.toLocaleDateString("en-GB", { month: "long" });
        const year = date.getFullYear();
        return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
    };


    const handleLoadMore = () => {
        setVisibleRows((prev) => prev + 1); // Add another row on button click
    };

    useEffect(() => {
        // Dynamically load the widget script
        const script = document.createElement("script");
        script.src = "https://ocpomni.alendei.io/js/widget/mzzpadohxkpzkhtr/float.js";
        script.id = "wa-widget";
        script.setAttribute("widget-id", "aaa5le"); // works as custom attribute
        script.async = true;
        document.body.appendChild(script);

        return () => {
            // Cleanup when component unmounts
            document.body.removeChild(script);
        };
    }, []);
    return (
        <React.Fragment>
            <div style={{ maxWidth: "900px", margin: "auto", padding: "20px" }}>
                {/* Search Bar with Mic */}

                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    {/* Category Buttons */}
                    <div style={{ display: "flex", gap: "8px" }}>
                        {["Buy", "Sell", "Rent", "Lease"].map((category) => (
                            <button
                                key={category}
                                onClick={() => handleCategoryClick(category)}
                                style={{
                                    padding: "8px 16px",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    background: "linear-gradient(135deg, #5A189A, #9D4EDD)", // Gradient purple
                                    color: "#fff",
                                    border: "1px solid #9D4EDD", // Light border for definition
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    transition: "all 0.3s ease",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px", // Space for potential icon
                                    boxShadow: "0 3px 10px rgba(157, 78, 221, 0.3)", // Soft shadow
                                }}
                                onMouseEnter={(e) => (e.target.style.filter = "brightness(1.2)")}
                                onMouseLeave={(e) => (e.target.style.filter = "brightness(1)")}
                            >
                                {category}
                            </button>
                        ))}
                    </div>

                    {/* Search Bar */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "8px",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            backgroundColor: "#fff",
                        }}
                    >
                        <Search size={18} style={{ marginRight: "8px" }} />
                        <input
                            type="text"
                            placeholder="Search web stories..."
                            value={searchQuery}
                            onChange={(e) => handleSearch(e.target.value)}
                            style={{ flex: 1, border: "none", outline: "none", fontSize: "16px" }}
                        />
                        {searchQuery && <X size={18} style={{ cursor: "pointer", marginRight: "8px" }} onClick={clearSearch} />}
                        <button
                            type="button"
                            className="d-flex align-items-center justify-content-center rounded-circle"
                            onClick={isListening ? stopListening : startListening}
                            style={{
                                width: "35px",
                                height: "35px",
                                background: isListening
                                    ? "linear-gradient(135deg, #ff416c,rgb(188, 43, 255))"
                                    : "linear-gradient(135deg, #6a11cb, #2575fc)",
                                transition: "all 0.3s ease-in-out",
                                boxShadow: isListening
                                    ? "0 0 10px rgba(255, 65, 108, 0.7), 0 0 20px rgba(255, 75, 43, 0.6)"
                                    : "0 0 8px rgba(26, 115, 232, 0.5)",
                                animation: isListening ? "pulse 1.5s infinite" : "none",
                                border: "none",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            {isListening ? (
                                <FaMicrophoneSlash size={16} color="white" />
                            ) : (
                                <FaMicrophone size={16} color="white" />
                            )}
                        </button>
                    </div>
                </div>

                <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", gap: "20px", marginTop: "20px" }}>
                    {/* Scrollable Stories Container */}
                    <div style={{ width: "100%", overflowX: "auto", paddingBottom: "10px" }}>
                        {Array.from({ length: visibleRows }).map((_, rowIndex) => (
                            <div key={rowIndex}
                                style={{
                                    display: "flex",
                                    gap: "15px",
                                    padding: "10px",
                                    overflowX: "auto",
                                    whiteSpace: "nowrap",
                                    scrollSnapType: "x mandatory",
                                    scrollbarWidth: "thin",
                                }}
                            >
                                {filteredStories
                                    .slice(rowIndex * storiesPerRow, (rowIndex + 1) * storiesPerRow)
                                    .map((story, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                position: "relative",
                                                width: "200px",
                                                height: "300px",
                                                cursor: "pointer",
                                                backgroundColor: "#1E253A",
                                                borderRadius: "10px",
                                                overflow: "hidden",
                                                scrollSnapAlign: "start",
                                                flexShrink: 0,
                                            }}
                                            onClick={() => navigate(`/webstories/${story.title.replace(/\s+/g, "-")}`)}
                                        >
                                            <img
                                                // src={`http://localhost:5000${story.details?.[0]?.img}`}
                                                src={`https://aiinrealestate.in/api${story.details?.[0]?.img}`}
                                                alt={story.title}
                                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                            />
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: "8px",
                                                    left: "8px",
                                                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                                                    color: "#fff",
                                                    padding: "4px 6px",
                                                    fontSize: "12px",
                                                    fontWeight: "bold",
                                                    borderRadius: "4px",
                                                }}
                                            >
                                                {story.title.length > 20 ? story.title.slice(0, 20) + "..." : story.title}
                                            </div>

                                            <div
                                                style={{
                                                    position: "absolute",
                                                    bottom: "8px",
                                                    left: "8px",
                                                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                                                    color: "#fff",
                                                    padding: "2px 6px",
                                                    fontSize: "10px",
                                                    borderRadius: "4px",
                                                }}
                                            >
                                                {formatDateWithSuffix(story.date)}
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        ))}
                    </div>

                    {/* Load More Button */}
                    {visibleRows * storiesPerRow < filteredStories.length && (
                        <button
                            onClick={handleLoadMore}
                            style={{
                                padding: "8px 16px",
                                fontSize: "14px",
                                fontWeight: "bold",
                                background: "linear-gradient(135deg, #5A189A, #9D4EDD)", // Gradient purple
                                color: "#fff",
                                border: "1px solid #9D4EDD", // Light border for definition
                                borderRadius: "6px",
                                cursor: "pointer",
                                transition: "all 0.3s ease",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px", // Space for potential icon
                                boxShadow: "0 3px 10px rgba(157, 78, 221, 0.3)", // Soft shadow
                            }}
                            onMouseEnter={(e) => (e.target.style.filter = "brightness(1.2)")}
                            onMouseLeave={(e) => (e.target.style.filter = "brightness(1)")}
                        >
                            Load More
                        </button>

                    )}
                </div>
                <br />

                {/* <div style={{
                display: "flex",
                gap: "20px",
                marginTop: "20px",
                alignItems: "flex-start",
                flexWrap: "wrap",
                justifyContent: "center"
            }}>
                <div style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                    gap: "15px",
                    flex: "1",
                    maxWidth: "65%",
                }}>
                    {filteredStories.length === 0 ? (
                        <p>No stories found.</p>
                    ) : (
                        filteredStories.map((story, index) => (
                            <div
                                key={index}
                                style={{
                                    position: "relative",
                                    width: "200px",
                                    height: "300px",
                                    cursor: "pointer",
                                    backgroundColor: "#1E253A",
                                    borderRadius: "10px",
                                    overflow: "hidden",
                                }}
                                onClick={() => navigate(`/webstories/${story.title.replace(/\s+/g, "-")}`)}
                            >
                                <img
                                    src={`https://aiinrealestate.in/api${story.details?.[0]?.img}`}
                                    alt={story.title}
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "8px",
                                        left: "8px",
                                        backgroundColor: "rgba(0, 0, 0, 0.6)",
                                        color: "#fff",
                                        padding: "4px 6px",
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                        borderRadius: "4px",
                                    }}
                                >
                                    {story.title.length > 20 ? story.title.slice(0, 20) + "..." : story.title}
                                </div>

                                <div
                                    style={{
                                        position: "absolute",
                                        bottom: "8px",
                                        left: "8px",
                                        backgroundColor: "rgba(0, 0, 0, 0.6)",
                                        color: "#fff",
                                        padding: "2px 6px",
                                        fontSize: "10px",
                                        borderRadius: "4px",
                                    }}
                                >
                                    {formatDateWithSuffix(story.date)}
                                </div>
                            </div>
                        ))
                    )}
                </div>

            </div> */}
                <div style={{
                    width: "250px",
                    height: "400px",
                    borderRadius: "10px",
                    overflow: "hidden",
                    flexShrink: "0"
                }}>
                    <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/GRjuS63f2x8?autoplay=1&mute=1"
                        title="YouTube Shorts"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{ borderRadius: "10px" }}
                    ></iframe>
                </div>

            </div >
            <div style={{ maxWidth: "2800px", margin: "0px", padding: "0px" }}>

                <Footer />
            </div>
        </React.Fragment>
    );
};

export default WebStories2;
